const state = {
  usersList: [],
  user: null,
  podUser: null,
};
const mutations = {
  SET_DOD_USERS_LIST(state, users) {
    state.usersList = users;
  },
  SET_DOD_USER(state, user) {
    state.user = user;
  },
  SET_POD_USER(state, user) {
    state.podUser = user;
  },
};
const getters = {
  getDodUsersList: (state) => state.usersList,
  getDodUser: (state) => state.user,
  getPodUser: (state) => state.podUser,
};

export default {
  state,
  mutations,
  getters,
};
